import { render, staticRenderFns } from "./surface.vue?vue&type=template&id=8becd58e&scoped=true&"
import script from "./surface.vue?vue&type=script&lang=js&"
export * from "./surface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8becd58e",
  null
  
)

export default component.exports